import { Button, Flex, Text } from 'rebass';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../../../styles/theme';
import { LogoSvg } from './Logo';
import { TEXT_ANIMATION_DURATION } from './constants';
import { isMobile } from 'react-device-detect';
const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const Description = styled(Text)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  align-items: ${(props) => (isMobile ? 'stretch' : 'flex-end')};
`;

export const Bmi = ({ onContinue, state }) => {
  const descriptionPre = `Your BMI is:`;
  const descriptionPost = state['bmi'] > 30 ? `(Above healthy weight).` : state['bmi'] > 27 ? `(Slightly above healthy weight)` : ``;
  const descriptionPost2 =
  state['bmi'] > 30
      ? `Losing just 5% of your body weight can seriously reduce the chance of heart disease.`
      : state['bmi'] > 27
        ? `Losing just 5% of your body weight can seriously reduce the chance of heart disease.`
        : `You’re not eligible for this program.`;

  return (
    <Flex flexDirection={'column'} flex={1}>
      <LogoSvg />
      <Flex flexWrap={'wrap'} mt={4} justifyContent={isMobile ? 'center' : ''}>
        {descriptionPre.split(' ').map((x, i) => {
          return (
            <Description key={`descriptionPre_${x}_i`} style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500, animationDelay: `${i * TEXT_ANIMATION_DURATION}s` }}>
              {x}
              &nbsp;
            </Description>
          );
        })}
        <Description style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500, color: theme.color.pink, animationDelay: `${descriptionPre.split(' ').length * TEXT_ANIMATION_DURATION}s` }}>
          {`${state['bmi']}`}
          &nbsp;
        </Description>
        {descriptionPost.split(' ').map((x, i) => {
          const dlay = i * TEXT_ANIMATION_DURATION;
          return (
            <Description
              key={`descriptionPost_${x}_i`}
              style={{ whiteSpace: 'pre-line', fontSize: isMobile ? '26px' : '32px', fontWeight: 500, animationDelay: `${(descriptionPre.split(' ').length + 2) * TEXT_ANIMATION_DURATION + dlay}s` }}
            >
              {x}
              &nbsp;
            </Description>
          );
        })}
        <Flex flexWrap={'wrap'} mt={3} justifyContent={isMobile ? 'center' : ''}>
          {descriptionPost2.split(' ').map((x, i) => {
            const dlay = i * TEXT_ANIMATION_DURATION;
            return (
              <Description
                key={`descriptionPost2${x}_i`}
                style={{
                  whiteSpace: 'pre-line',
                  fontSize: isMobile ? '26px' : '32px',
                  fontWeight: 500,
                  animationDelay: `${(descriptionPre.split(' ').length + descriptionPost.split(' ').length + 2) * TEXT_ANIMATION_DURATION + dlay}s`,
                }}
              >
                {x}
                &nbsp;
              </Description>
            );
          })}
        </Flex>
      </Flex>

      <FootNote mb={4} isMobile={isMobile}>
        <Button variant={'primary'} onClick={onContinue} >
          Next
        </Button>
      </FootNote>
    </Flex>
  );
};
